import React from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";

// Hybrid share: Web Share API on mobile/supported browsers, clipboard fallback elsewhere.
export const ShareButton = ({ product, className = "", testId = "share-btn" }) => {
  const buildUrl = () => {
    if (typeof window === "undefined") return "";
    const base = `${window.location.origin}/?p=${encodeURIComponent(product.id)}`;
    return base;
  };

  const handleShare = async (e) => {
    e?.stopPropagation?.();
    const url = buildUrl();
    const text = `Check out ${product.title} on MastiBazaar`;
    const title = `MastiBazaar · ${product.title}`;

    const canNativeShare =
      typeof navigator !== "undefined" &&
      typeof navigator.share === "function";

    if (canNativeShare) {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch (err) {
        if (err && err.name === "AbortError") return;
        // fall through to clipboard
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      toast.success("Product Link Copied!", {
        description: "Paste it anywhere to share.",
        duration: 2400,
      });
    } catch {
      toast.error("Couldn't copy link", {
        description: "Please copy the URL manually.",
        duration: 2800,
      });
    }
  };

  return (
    <button
      onClick={handleShare}
      data-testid={testId}
      aria-label="Share this product"
      className={`inline-flex items-center justify-center gap-2 rounded-full text-sm font-medium transition-all hover:-translate-y-0.5 ${className}`}
    >
      <Share2 size={16} strokeWidth={1.8} />
      <span className="hidden sm:inline">Share</span>
    </button>
  );
};
